import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SaleEmployee } from 'src/app/core/_models/orga/sale-employee.model';
import { Employee } from '../../../_models/recipients/employee.model';

@Injectable({
    providedIn: 'root'
})
export class EppOrgaService {

    organisationResourceUrl = '/apiOrganisation';

    constructor(private http: HttpClient) {
    }


    getEmployeeByEmployeeNumber(employeeNumber: string): Observable<SaleEmployee>{
        return this.http.get<SaleEmployee>(this.organisationResourceUrl + '/v1/employees?employeeNumber=' + employeeNumber)
            .pipe(catchError((err, caught) => of(null)));
    }

}
